<template>
    <div class="container">
        <poster :poster-list="posterList"  :time-format="4" :page-path="pagePath" :module-key="moduleKey" :token="token"/>
    </div>
</template>

<script>
  import Poster from '../../../components/Poster/Index'

  export default {
    name: "SixFreeOne",
    components: {
      Poster
    },
    data() {
      return {
        token: this.$route.query.token,
        posterList: [
          {
            backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303110408517.png',
            tempBgImage: null,
            miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303110313931.png',
            textColor: '#ffffff',
            textFontSize: 28,
            tempPoster: '',
            textPoint: [429, 1205],
            wxCode: {width: 187, point: [58, 1133]}
          },
          {
            backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303105833450.png',
            tempBgImage: null,
            miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303110324057.png',
            textColor: '#ffffff',
            textFontSize: 28,
            tempPoster: '',
            textPoint: [429, 1205],
            wxCode: {width: 187, point: [58, 1133]}
          },
          {
            backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303111057267.png',
            tempBgImage: null,
            miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303111121716.png',
            textColor: '#ffffff',
            textFontSize: 28,
            tempPoster: '',
            textPoint: [429, 1205],
            wxCode: {width: 187, point: [58, 1133]}
          },
          {
            backgroundImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303111130939.png',
            tempBgImage: null,
            miniImage: 'http://freesaasofficedata.oss.aliyuncs.com/miShop/20220303111139151.png',
            textColor: '#ffffff',
            textFontSize: 28,
            tempPoster: '',
            textPoint: [429, 1205],
            wxCode: {width: 187, point: [58, 1133]}
          }
        ],
        pagePath: this.baseHost + '/',
        moduleKey: ''
      }
    },
    created() {
      this.moduleKey = this.token ? 'cb97de0e-6003-41b1-9c93-7b778dd67efb' : 'gzhFJScx20220305'
    }
  }
</script>

<style scoped>

</style>